module.exports = __webpack_public_path__ + "img/20190727141715QQ截图20190727023215.d47a35e3.png";